import Vue from 'vue'
import VueRouter from 'vue-router'
import Handbook from '@/mixins/HandbookAPI'
import Home from '@/views/Home'
import Parliamentarians from '@/views/Parliamentarians'
import Parliamentarian from '@/views/Parliamentarian'
import ParliamentarianDivisions from '@/views/Parliamentarian/ParliamentarianDivisions'
import StatisticalInformationCards from '@/views/StatisticalInformation/StatisticalInformationCards'
import Chronology from '@/views/StatisticalInformation/Chronology'
import MembersWhoHaveServedInBothChambers from '@/views/StatisticalInformation/MembersWhoHaveServedInBothChambers'
import LongestServingMembers from '@/views/StatisticalInformation/LongestServingMembers'
import WomenInParliament from '@/views/StatisticalInformation/WomenInParliament'
import GenderCompositionOfParliament from '@/views/StatisticalInformation/GenderCompositionOfParliament'
import WomenInCommittees from '@/views/StatisticalInformation/WomenInCommittees'
import WomenInMinistries from '@/views/StatisticalInformation/WomenInMinistries'
import CommitteeTimeline from '@/views/StatisticalInformation/CommitteeTimeline'
import PrimeMinisterStatistics from '@/views/StatisticalInformation/PrimeMinisters'
import LeadersOfTheOpposition from '@/views/StatisticalInformation/LeadersOfTheOpposition'
import PartyRepresentation from '@/views/StatisticalInformation/PartyRepresentation'
import Composition from '@/views/StatisticalInformation/Composition'
import Age from '@/views/StatisticalInformation/Age'
import LengthOfService from '@/views/StatisticalInformation/LengthOfService'
import PeriodOfService from '@/views/StatisticalInformation/PeriodOfService'
import PriorService from '@/views/StatisticalInformation/PriorService'
import LevelsOfQualifications from '@/views/StatisticalInformation/LevelsOfQualifications'
import FieldsOfQualifications from '@/views/StatisticalInformation/FieldsOfQualifications'
import PreviousOccupation from '@/views/StatisticalInformation/PreviousOccupation'
import OverseasBorn from '@/views/StatisticalInformation/OverseasBorn'
import CommitteeStatistics from '@/views/StatisticalInformation/CommitteeStatistics'
import CommitteeMembershipStatistics from '@/views/StatisticalInformation/CommitteeMembershipStatistics'
import CommitteeSankey from '@/views/StatisticalInformation/CommitteeSankey'
import CommitteeSankeyNew from '@/views/StatisticalInformation/CommitteeSankeyNew'
import CommitteeChronology from '@/views/StatisticalInformation/CommitteeChronology'
import ChangedParties from '@/views/StatisticalInformation/ChangedParties'
import ChangedElectorate from '@/views/StatisticalInformation/ChangedElectorate'
import IndigenousParliamentarians from '@/views/StatisticalInformation/IndigenousParliamentarians'
import ElectionProportionality from '@/views/StatisticalInformation/ElectionProportionality'
import SittingDays from '@/views/StatisticalInformation/SittingDays'
import SittingDayCalendar from '@/views/StatisticalInformation/SittingDayCalendar'
import Divisions from '@/views/StatisticalInformation/Divisions'
import DivisionsForYear from '@/views/StatisticalInformation/DivisionsForYear'
import Division from '@/views/StatisticalInformation/Division';
import Timeline from '@/views/StatisticalInformation/SuperTimeline'
import DynamicTimeline from '@/views/StatisticalInformation/DynamicTimeline'
import PrimeMinistersTimeline from '@/views/StatisticalInformation/PrimeMinistersTimeline'
import LeadersOfTheOppositionTimeline from '@/views/StatisticalInformation/LeadersOfTheOppositionTimeline'
import ParliamentaryOfficeHoldersPage from '@/views/StatisticalInformation/ParliamentaryOfficeHoldersPage'
import AdvancedSearch from '@/views/AdvancedSearch/AdvancedSearch'
import AdvancedSearchDivisions from '@/views/AdvancedSearch/AdvancedSearchDivisions'
import AdvancedSearchLanding from '@/views/AdvancedSearch/AdvancedSearchLanding'
import HistoricalInformation from '@/views/HistoricalInformation/HistoricalInformation'
import HeadsOfState from '@/views/HistoricalInformation/HeadsOfState'
import GovernorsGeneral from '@/views/HistoricalInformation/GovernorsGeneral'
import GovernorGeneral from '@/views/HistoricalInformation/GovernorGeneral'
import Monarch from '@/views/HistoricalInformation/Monarch'
import Presidents from '@/views/HistoricalInformation/Presidents'
import Speakers from '@/views/HistoricalInformation/Speakers'
import PrimeMinisters from '@/views/HistoricalInformation/PrimeMinisters'
import OfficeHolders from '@/views/HistoricalInformation/OfficeHolders'
import ParliamentaryOfficeHolder from '@/views/HistoricalInformation/ParliamentaryOfficeHolder'
import ElectorateMaps from '@/views/ElectorateMaps'
import Electorates from '@/views/Electorates'
import Electorate from '@/views/Electorate'
import ElectionsLayout from '@/views/Elections/ElectionsLayout'
import FullElections from '@/views/Elections/FullElections'
import FullElection from '@/views/Elections/FullElection'
import ByElections from '@/views/Elections/ByElections'
import FullElectionDivisionalResults from '@/views/Elections/FullElectionDivisionalResults'
import FullElectionDivisionalResult from '@/views/Elections/FullElectionDivisionalResult'
import ByElectionResults from '@/views/Elections/ByElectionResults'
import SenateFullElectionStateResults from '@/views/Elections/SenateFullElectionStateResults'
import SenateCandidates from '@/views/Elections/SenateCandidates'
import SenatorsElected from '@/views/Elections/SenatorsElected'
import Candidates from '@/views/Elections/Candidates'
import MembersElected from '@/views/Elections/MembersElected'
import SenateFullElectionStateResult from '@/views/Elections/SenateFullElectionStateResult'
import SenateFirstPreferencesByGroup from '@/views/Elections/SenateFirstPreferencesByGroup'
import SenateByCandidate from '@/views/Elections/SenateByCandidate'
import SenateDivision from '@/views/Elections/SenateDivision'
import SenatePollingPlace from '@/views/Elections/SenatePollingPlace'
import Referendums from '@/views/Referendums/Referendums'
import Referendum from '@/views/Referendums/Referendum'
import ReferendumDivisionalResults from '@/views/Referendums/ReferendumDivisionalResults'
import RoyalCommissions from '@/views/RoyalCommissions/RoyalCommissions'
import MinisterialStatements from '@/views/MinisterialStatements/MinisterialStatements'
import MinisterialStatementStatistics from '@/views/StatisticalInformation/MinisterialStatements';
import ElectionsSankey from '@/views/StatisticalInformation/ElectionsSankey';
import PollingPlace from '@/views/Elections/PollingPlace'
import Ministries from '@/views/Ministries'
import Ministry from '@/views/Ministry'
import ShadowMinistries from '@/views/ShadowMinistries'
import ShadowMinistry from '@/views/ShadowMinistry'
import Committees from '@/views/Committees/Committees'
import Committee from '@/views/Committees/Committee'
import Parliaments from '@/views/Parliaments'
import Parties from '@/views/StatisticalInformation/Parties'
import Party from '@/views/StatisticalInformation/Party'
import States from '@/views/States'
import State from '@/views/State'
import Help from '@/views/Help'
import DIAGNOSTICS from '@/views/DIAGNOSTICS'

Vue.use(VueRouter);

var router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior (_to, _from, savedPosition) {
        return new Promise(resolve => {
            setTimeout(() => {
                if (savedPosition) {
                    resolve(savedPosition);
                } else {
                    resolve({ x: 0, y: 0 })
                }
            }, 200)
        })
    },

    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home,
            meta: { title: 'Australian Parliamentary Library Handbook - Home' },
            props: false
        },
        {
            path: '/Parliamentarians',
            name: 'Parliamentarians',
            component: Parliamentarians,
            meta: { title: 'Parliamentarians' },
            props: false
        },
        {
            path: '/Committees',
            name: 'Committees',
            component: Committees,
            meta: { title: 'Committees' },
            props: true
        },
        {
            path: '/Committees/Committee/:CID',
            name: 'Committee',
            component: Committee,
            meta: { title: 'Committee' },
            props: route => {
                return { ...route.params, default: true };
            }
        },
        {
            path: '/Parliamentarian/:PHID',
            name: 'Parliamentarian',
            component: Parliamentarian,
            meta: { title: 'Parliamentarian' },
            props: true
        },
        {
            path: '/Parliamentarian/:PHID/Divisions',
            name: 'ParliamentarianDivisions',
            component: ParliamentarianDivisions,
            meta: { title: 'Parliamentarian divisions' },
            props: true
        },
        {
            path: '/StatisticalInformation',
            name: 'StatisticalInformation',
            component: StatisticalInformationCards,
            meta: { title: 'Statistical Information'},
            props: false
        },
        {
            path: '/StatisticalInformation/Timeline',
            name: 'Timeline',
            component: DynamicTimeline,
            meta: { title: 'Dynamic Timeline'},
            props: false
        },
        {
            path: '/StatisticalInformation/ParliamentaryTimeline',
            name: 'ParliamentaryTimeline',
            component: Timeline,
            meta: { title: 'Parliamentary Timeline'},
            props: false
        },        
        {
            path: '/StatisticalInformation/OfficeHolderTimeline',
            name: 'OfficeHolderTimeline',
            component: ParliamentaryOfficeHoldersPage,
            meta: { title: 'Parliamentary office holder timeline'},
            props: false
        },
        {
            path: '/StatisticalInformation/PrimeMinistersTimeline',
            name: 'PrimeMinistersTimeline',
            component: PrimeMinistersTimeline,
            meta: { title: 'Prime Ministers timeline'},
            props: false
        },
        {
            path: '/StatisticalInformation/LeadersOfTheOppositionTimeline',
            name: 'LeadersOfTheOppositionTimeline',
            component: LeadersOfTheOppositionTimeline,
            meta: { title: 'Leaders of the Opposition timeline'},
            props: false
        },
        {
            path: '/StatisticalInformation/Chronology',
            name: 'Chronology',
            component: Chronology,
            meta: { title: 'Chronology of Parliaments'},
            props: false
        },
        {
            path: '/StatisticalInformation/WomenInCommittees',
            name: 'WomenInCommittees',
            component: WomenInCommittees,
            meta: { title: 'Women in committees'},
            props: false
        },
        {
            path: '/StatisticalInformation/WomenInMinistries',
            name: 'WomenInMinistries',
            component: WomenInMinistries,
            meta: { title: 'Women in ministries'},
            props: false
        },
        {
            path: '/StatisticalInformation/ChangedParties',
            name: 'ChangedParties',
            component: ChangedParties,
            meta: { title: 'Parliamentarians who changed parties'},
            props: false
        },
        {
            path: '/StatisticalInformation/ChangedElectorate',
            name: 'ChangedElectorate',
            component: ChangedElectorate,
            meta: { title: 'Parliamentarians who changed electorate/state'},
            props: false
        },
        {
            path: '/StatisticalInformation/IndigenousParliamentarians',
            name: 'IndigenousParliamentarians',
            component: IndigenousParliamentarians,
            meta: { title: 'Aboriginal and/or Torres Strait Islander Parliamentarians'},
            props: false
        },
         {
            path: '/StatisticalInformation/CommitteeTimeline',
            name: 'CommitteeTimeline',
            component: CommitteeTimeline,
            meta: { title: 'Committee timeline'},
            props: false
        },
        {
            path: '/StatisticalInformation/PartyRepresentation',
            name: 'PartyRepresentation',
            component: PartyRepresentation,
            meta: { title: 'Party Representation in each Parliament'},
            props: false
        },
        {
            path: '/StatisticalInformation/MembersWhoHaveServedInBothChambers',
            name: 'MembersWhoHaveServedInBothChambers',
            component: MembersWhoHaveServedInBothChambers,
            meta: { title: 'Members who have served in both chambers'},
            props: false
        },
        {
            path: '/StatisticalInformation/LongestServingMembers',
            name: 'LongestServingMembers',
            component: LongestServingMembers,
            meta: { title: 'Longest serving members (over 20 years)'},
            props: false
        },
        {
            path: '/StatisticalInformation/WomenInParliament',
            name: 'WomenInParliament',
            component: WomenInParliament,
            meta: { title: 'List of all women in Parliament'},
            props: false
        },       
        {
            path: '/StatisticalInformation/GenderCompositionOfParliament',
            name: 'GenderCompositionOfParliament',
            component: GenderCompositionOfParliament,
            meta: { title: 'Gender composition in each Parliament'},
            props: false
        },
        {
            path: '/StatisticalInformation/CommitteeStatistics',
            name: 'CommitteeStatistics',
            component: CommitteeStatistics,
            meta: { title: 'Committee statistics'},
            props: false
        },
        {
            path: '/StatisticalInformation/CommitteeMembershipStatistics',
            name: 'CommitteeMembershipStatistics',
            component: CommitteeMembershipStatistics,
            meta: { title: 'Committee membership statistics'},
            props: false
        },
        {
             path: '/StatisticalInformation/CommitteeSankey',
             name: 'CommitteeSankey',
             component: CommitteeSankey,
             meta: { title: 'Committee sankey'},
             props: false
         },
         {
             path: '/StatisticalInformation/CommitteeSankeyNew',
             name: 'CommitteeSankeyNew',
             component: CommitteeSankeyNew,
             meta: { title: 'Committee sankey'},
             props: false
         },
         {
             path: '/StatisticalInformation/CommitteeChronology',
             name: 'CommitteeChronology',
             component: CommitteeChronology,
             meta: { title: 'Committee chronology'},
             props: false
         },
        {
            path: '/StatisticalInformation/SittingPattern',
            name: 'SittingDayStatistics',
            component: SittingDays,
            meta: { title: 'Sitting pattern statistics'},
            props: false
        },
        {
            path: '/StatisticalInformation/SittingPattern/:year',
            name: 'SittingDayCalendar',
            component: SittingDayCalendar,
            meta: { title: 'Sitting pattern calendar'},
            props: true
        },
        {
            path: '/StatisticalInformation/Divisions',
            name: 'DivisionsStatistics',
            component: Divisions,
            meta: { title: 'Divisions statistics'},
            props: false
        },
        {
            path: '/StatisticalInformation/Divisions/Division/:id',
            name: 'DivisionIndividual',
            component: Division,
            meta: { title: 'Division'},
            props: true
        },        
        {
            path: '/StatisticalInformation/Divisions/:chamber/:parliament',
            name: 'DivisionsForParliament',
            component: DivisionsForYear,
            meta: { title: 'Divisions for parliament'},
            props: true
        },
        {
            path: '/StatisticalInformation/Divisions/:chamber/:parliament/:id',
            name: 'Division',
            component: Division,
            meta: { title: 'Division'},
            props: true
        },
        {
            path: '/StatisticalInformation/PrimeMinisters',
            name: 'PrimeMinisters',
            component: PrimeMinisterStatistics,
            meta: { title: 'Prime Ministers'},
            props: false
        },
        {
            path: '/StatisticalInformation/LeadersOfTheOpposition',
            name: 'LeadersOfTheOpposition',
            component: LeadersOfTheOpposition,
            meta: { title: 'Leaders of the Opposition'},
            props: false
        },
        {
            path: '/StatisticalInformation/Composition',
            name: 'CompositionOfTheParliament',
            component: Composition,
            meta: { title: 'Parties by state'},
            props: false
        },
        {
            path: '/StatisticalInformation/Age',
            name: 'Age',
            component: Age,
            meta: { title: 'Age groups and distribution'},
            props: false
        },
        {
            path: '/StatisticalInformation/LengthOfService',
            name: 'LengthOfService',
            component: LengthOfService,
            meta: { title: 'Length of service groups and distribution'},
            props: false
        },
        {
            path: '/StatisticalInformation/PeriodOfService',
            name: 'PeriodOfService',
            component: PeriodOfService,
            meta: { title: 'Periods of service'},
            props: false
        },
        {
            path: '/StatisticalInformation/PriorElectedServiceInGovernment',
            name: 'PriorElectedServiceInGovernment',
            component: PriorService,
            meta: { title: 'Prior elected service in government'},
            props: false
        },
        {
            path: '/StatisticalInformation/LevelsOfQualifications',
            name: 'LevelsOfQualifications',
            component: LevelsOfQualifications,
            meta: { title: 'Levels of qualifications'},
            props: false
        },
        {
            path: '/StatisticalInformation/FieldsOfQualifications',
            name: 'FieldsOfQualifications',
            component: FieldsOfQualifications,
            meta: { title: 'Fields of qualifications'},
            props: false
        },
        {
            path: '/StatisticalInformation/PreviousOccupation',
            name: 'PreviousOccupation',
            component: PreviousOccupation,
            meta: { title: 'Previous occupation'},
            props: false
        },
        {
            path: '/StatisticalInformation/Parties',
            name: 'Parties',
            component: Parties,
            meta: { title: 'Parties' },
            props: true
        },
        {
            path: '/StatisticalInformation/Party/:Party',
            name: 'Party',
            component: Party,
            meta: { title: 'Party' },
            props: true
        },
        {
            path: '/StatisticalInformation/MinisterialStatements',
            name: 'MinisterialStatementStatistics',
            component: MinisterialStatementStatistics,
            meta: { title: 'Ministerial statement statistics' },
            props: false
        },
        {
            path: '/StatisticalInformation/ElectionsSankey',
            name: 'ElectionsSankey',
            component: ElectionsSankey,
            meta: { title: 'Elections Sankey' },
            props: false
        },
        // {
        //     path: '/StatisticalInformation/ElectionProportionality',
        //     name: 'ElectionProportionality',
        //     component: ElectionProportionality,
        //     meta: { title: 'Difference between votes received and seats won'},
        //     props: false
        // },
        {
            path: '/StatisticalInformation/OverseasBorn',
            name: 'OverseasBorn',
            component: OverseasBorn,
            meta: { title: 'Overseas Born'},
            props: false
        },
        {
            path: '/HistoricalInformation',
            name: 'HistoricalInformation',
            component: HistoricalInformation,
            meta: { title: 'Governors-General and Statutory Office Holders'},
            props: false
        },
        {
            path: '/HeadsOfState',
            name: 'HeadsOfState',
            component: HeadsOfState,
            meta: { title: 'Heads of State'},
            props: false
        },
        {
            path: '/GovernorsGeneral',
            name: 'GovernorsGeneral',
            component: GovernorsGeneral,
            meta: { title: 'Governors-General'},
            props: false
        },
        {
            path: '/GovernorsGeneral/:id',
            name: 'GovernorGeneral',
            component: GovernorGeneral,
            meta: { title: 'Governor-General'},
            props: true
        },
        {
            path: '/Monarchs/:id',
            name: 'Monarch',
            component: Monarch,
            meta: { title: 'Monarch'},
            props: true
        },        
        {
            path: '/Presidents',
            name: 'Presidents',
            component: Presidents,
            meta: { title: 'Presidents and Deputy Presidents'},
            props: false
        },
        {
            path: '/Speakers',
            name: 'Speakers',
            component: Speakers,
            meta: { title: 'Speakers and Deputy Speakers'},
            props: false
        },
        {
            path: '/PrimeMinisters',
            name: 'PrimeMinistersHistorical',
            component: PrimeMinisters,
            meta: { title: 'Prime Ministers'},
            props: false
        },
        {
            path: '/OfficeHolders',
            name: 'OfficeHolders',
            component: OfficeHolders,
            meta: { title: 'Parliamentary office holders'},
            props: false
        },
        {
            path: '/ParliamentaryOfficeHolder/:id',
            name: 'ParliamentaryOfficeHolder',
            component: ParliamentaryOfficeHolder,
            meta: { title: 'Parliamentary office holder'},
            props: true
        },              
        {
            path: '/AdvancedSearch',
            name: 'AdvancedSearch',
            component: AdvancedSearchLanding,
            meta: { title: 'Advanced Search'},            
            children: [
                {
                    path: '',
                    redirect: '/AdvancedSearch/Parliamentarians'
                },
                {
                    path: '/AdvancedSearch/Parliamentarians',
                    name: 'AdvancedSearchParliamentarians',
                    component: AdvancedSearch,
                    meta: { title: 'Advanced Search'},            
                },        
                {
                    path: '/AdvancedSearch/Divisions',
                    name: 'AdvancedSearchDivisions',
                    component: AdvancedSearchDivisions,
                    meta: { title: 'Advanced Search Divisions'},            
                }
            ]
        }, 
        {
            path: '/ElectorateMaps',
            name: 'ElectorateMaps',
            component: ElectorateMaps,
            meta: { title: 'Distribution Boundaries' },
            props: true
        },
        {
            path: '/Electorates',
            name: 'Electorates',
            component: Electorates,
            meta: { title: 'Electorates' },
            props: true
        },
        {
            path: '/Electorate/:Electorate/State/:State',
            name: 'Electorate',
            component: Electorate,
            meta: { title: 'Electorate' },
            props: true
        },
        {
            path: '/Elections',
            name: 'Elections',
            component: ElectionsLayout,
            meta: { title: 'Elections' },
            props: true,
            children: [
                {
                    path: '/Elections',
                    name: 'FullElections',
                    component: FullElections,
                    meta: { title: 'Elections' },
                    props: true
                },
                {
                    path: '/Elections/:year/:electionId/ByDivision',
                    name: 'DivisionalResults',
                    component: FullElectionDivisionalResults,
                    meta: { title: 'Divisional Results' },
                    props: true
                },
                {
                    path: '/Elections/:year/:electionId',
                    name: 'FullElection',
                    component: FullElection,
                    meta: { title: 'Election' },
                    props: true
                }, 
                {
                    path: '/Elections/ByElections/:year/:electionId/:division',
                    name: 'ByElectionResults',
                    component: ByElectionResults,
                    meta: { title: 'By Election Results' },
                    props: true
                },
                {
                    path: '/Elections/:year/:electionId/Candidates',
                    name: 'Candidates',
                    component: Candidates,
                    meta: { title: 'Candidates' },
                    props: true
                },        
                {
                    path: '/Elections/:year/:electionId/Elected',
                    name: 'MembersElected',
                    component: MembersElected,
                    meta: { title: 'Members Elected' },
                    props: true
                },
                {
                    path: '/Elections/:year/:electionId/ByDivision/:division',
                    name: 'DivisionalResult',
                    component: FullElectionDivisionalResult,
                    meta: { title: 'Divisional Result' },
                    props: true
                },
                {
                    path: '/Elections/:year/:electionId/Senate/ByState',
                    name: 'SenateResultsByState',
                    component: SenateFullElectionStateResults,
                    meta: { title: 'Senate State Results' },
                    props: true
                },
                {
                    path: '/Elections/:year/:electionId/Senate/Candidates',
                    name: 'SenateCandidates',
                    component: SenateCandidates,
                    meta: { title: 'Senate Candidates' },
                    props: true
                },     
                {
                    path: '/Elections/:year/:electionId/Senate/Elected',
                    name: 'SenatorsElectedAll',
                    component: SenatorsElected,
                    meta: { title: 'Senators Elected' },
                    props: true
                },           
                {
                    path: '/Elections/:year/:electionId/Senate/ByState/:state/Elected',
                    name: 'SenatorsElected',
                    component: SenatorsElected,
                    meta: { title: 'Senators Elected' },
                    props: true
                },           
                {
                    path: '/Elections/:year/:electionId/Senate/ByState/:state',
                    name: 'SenateResultByState',
                    component: SenateFullElectionStateResult,
                    meta: { title: 'Senate State Results' },
                    props: true
                },
                {
                    path: '/Elections/:year/:electionId/Senate/ByState/:state/ByGroup',
                    name: 'SenateResultByGroup',
                    component: SenateFirstPreferencesByGroup,
                    meta: { title: 'Senate State Group Results' },
                    props: true
                },
                {
                    path: '/Elections/:year/:electionId/Senate/ByState/:state/ByCandidate',
                    name: 'SenateResultByCandidate',
                    component: SenateByCandidate,
                    meta: { title: 'Senate State Candidate Results' },
                    props: true
                },
                {
                    path: '/Elections/:year/:electionId/Senate/ByState/:state/:division',
                    name: 'SenateResultByDivision',
                    component: SenateDivision,
                    meta: { title: 'Senate State Candidate Results' },
                    props: true
                },
                {
                    path: '/Elections/:year/:electionId/Senate/ByState/:state/:division/:pollingPlace',
                    name: 'SenatePollingPlace',
                    component: SenatePollingPlace,
                    meta: { title: 'Polling Place' },
                    props: true
                },           
                {
                    path: '/Elections/:year/:electionId/ByDivision/:division/:pollingPlace',
                    name: 'PollingPlace',
                    component: PollingPlace,
                    meta: { title: 'Polling Place' },
                    props: true
                },        
                {
                    path: '/Elections/ByElections',
                    name: 'ByElections',
                    component: ByElections,
                    meta: { title: 'By Elections' },
                    props: true
                },
                {
                    path: '/Referendums',
                    name: 'Referendums',
                    component: Referendums,
                    meta: { title: 'Referendums' },
                    props: true
                },
                {
                    path: '/Referendums/:id',
                    name: 'Referendum',
                    component: Referendum,
                    meta: { title: 'Referendum' },
                    props: true
                },
                {
                    path: '/Referendums/:id/:state',
                    name: 'ReferendumDivision',
                    component: ReferendumDivisionalResults,
                    meta: { title: 'Referendum' },
                    props: true
                },
                {
                    path: '/RoyalCommissions',
                    name: 'RoyalCommissions',
                    component: RoyalCommissions,
                    meta: { title: 'Royal Commissions' },
                    props: true
                },
                {
                    path: '/MinisterialStatements',
                    name: 'MinisterialStatements',
                    component: MinisterialStatements,
                    meta: { title: 'Ministerial Statements'},
                    props: true
                }
            ]
        },
        {
            path: '/Ministries',
            name: 'Ministries',
            component: Ministries,
            meta: { title: 'Ministries' },
            props: true
        },
        {
            path: '/Ministry/:MID',
            name: 'Ministry',
            component: Ministry,
            meta: { title: 'Ministry' },
            props: route => {
                const ministryId = Number.parseInt(route.params.MID);
                if (Number.isNaN(ministryId)) {
                    return { ...route.params, default: true, MID: 0 };
                }
                return { ...route.params, default: true, MID: ministryId };
            }
        },
        {
            path: '/ShadowMinistries',
            name: 'ShadowMinistries',
            component: ShadowMinistries,
            meta: { title: 'Shadow Ministries' },
            props: true
        },
        {
            path: '/ShadowMinistry/:SMID',
            name: 'ShadowMinistry',
            component: ShadowMinistry,
            meta: { title: 'Shadow Ministry' },
            props: route => {
                const shadowMinistryId = Number.parseInt(route.params.SMID);
                if (Number.isNaN(shadowMinistryId)) {
                    return { ...route.params, default: true, SMID: 0 };
                }
                return { ...route.params, default: true, SMID: shadowMinistryId };
            }
        },
        {
            path: '/Parliaments',
            name: 'Parliaments',
            component: Parliaments,
            meta: { title: 'Parliaments' },
            props: false
        },
        {
            path: '/States',
            name: 'States',
            component: States,
            meta: { title: 'States' },
            props: true
        },
        {
            path: '/State/:State',
            name: 'State',
            component: State,
            meta: { title: 'State' },
            props: true
        },
        {
            path: '/Help',
            name: 'Help',
            component: Help,
            meta: { title: 'Parliamentary Handbook Help' },
            props: true
        }
    ]
});

    router.addRoutes([{
        path: '/DIAGNOSTICS',
        name: 'DIAGNOSTICS',
        component: DIAGNOSTICS,
        meta: { title: 'DIAGNOSTICS' },
        props: true
    }]);

export default router;
